export enum LeaverContactInvoice{
    Digital = 'digital',
    ByPost = 'byPost'
}